var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:`btn-${_vm.color}`},[_c('div',{staticClass:"inner"},[_c('transition',{staticClass:"inner",attrs:{"name":"changed","mode":"out-in"}},[(!_vm.isLoading)?_c('div',{key:"buttonTitle"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.isLoading)?_c('spinner',{key:"spinner"}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }